
import BannerLeftCn from './images/banner-left.png';
import BannerRightCn from './images/banner-right.png';
import IllustrationCnNew1 from "./images/img-new-1.png"
import IllustrationCnNew1Com from './images/img-new-1-en.png';
import IllustrationCn1 from './images/img-1.png';
import IllustrationCom1 from './images/img-com-1.png';
import IllustrationCn2 from './images/img-2.png';
import IllustrationCom2 from './images/img-com-2.png';
import IllustrationCn3 from './images/img-3.png';
import IllustrationCom3 from './images/img-com-3.png';
import Atlas from "./images/atlas.png"
import AtlasCom from './images/atlas-en.png';
import { ImgSourceMap } from 'globalCommon/utils/index'

export const IMG_SOURCE: ImgSourceMap = {
    bannerLeft: {
        id: 'ai-technology-banner-left',
        src: BannerLeftCn,
    },
    bannerRight: {
        id: 'ai-technology-banner-right',
        src: BannerRightCn,
    },
    illustrationNew1: {
        id: 'ai-technology-IllustrationCnNew1',
        src: IllustrationCnNew1,
        srcEn: IllustrationCnNew1Com,
        srcCom: IllustrationCnNew1Com,
    },
    illustration1: {
        id: 'ai-technology-illustration1',
        src: IllustrationCn1,
        srcCom: IllustrationCom1,
    },
    illustration2: {
        id: 'ai-technology-illustration2',
        src: IllustrationCn2,
        srcCom: IllustrationCom2,
    },
    illustration3: {
        id: 'ai-technology-illustration3',
        src: IllustrationCn3,
        srcCom: IllustrationCom3,
    },
    atlas: {
        id: 'ai-technology-atlas',
        src: Atlas,
        srcEn: AtlasCom,
        srcCom: AtlasCom,
    },
};